import { Icon } from "@iconify/react/dist/iconify.js";
import ConfiguracionTalentosGlobal from "../../components/configuracionTalentos/ConfiguracionTalentosGlobal";
import VideoTutorialInicioQuiz from "../../components/configuracionTalentos/VideoTutorialInicioQuiz";

const ConfiguracionGlobalTalentosPage = () => {
  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h3 className="mb-1 fw-semibold">Configuración adicional</h3>
        <p className="text-muted mb-0 small">
          Parámetros globales que aplican a todos los planteles.
        </p>
      </div>

      <div className="row g-4 align-items-start">
        {/* Card compacta: configuración de talentos */}
        <div className="col-12 col-lg-4">
          <div className="card border-0 shadow-sm radius-8 h-100">
            <div className="card-header border-bottom bg-base py-3 px-4">
              <div className="d-flex align-items-center gap-2">
                <span className="bg-primary bg-opacity-10 rounded-circle p-2">
                  <Icon
                    icon="mdi:star-outline"
                    width={20}
                    className="text-primary"
                  />
                </span>
                <div className="text-start">
                  <h6 className="mb-0 fw-semibold">Configuración de talentos</h6>
                  <small className="text-muted">
                    Talentos más y menos destacados en resultados.
                  </small>
                </div>
              </div>
            </div>
            <div className="card-body py-4 px-4">
              <ConfiguracionTalentosGlobal />
            </div>
          </div>
        </div>

        {/* Card ancha: video tutorial con preview */}
        <div className="col-12 col-lg-8">
          <div className="card border-0 shadow-sm radius-8 h-100">
            <div className="card-header border-bottom bg-base py-3 px-4">
              <div className="d-flex align-items-center gap-2">
                <span className="bg-primary bg-opacity-10 rounded-circle p-2">
                  <Icon
                    icon="mdi:play-circle-outline"
                    width={20}
                    className="text-primary"
                  />
                </span>
                <div className="text-start">
                  <h6 className="mb-0 fw-semibold">
                    Video tutorial de inicio del quiz
                  </h6>
                  <small className="text-muted">
                    Video introductorio que verán todos los estudiantes antes de comenzar.
                  </small>
                </div>
              </div>
            </div>
            <div className="card-body py-4 px-4">
              <VideoTutorialInicioQuiz />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionGlobalTalentosPage;

